// removed by extract-text-webpack-plugin
module.exports = {"experimentContainer":"index-module_experimentContainer_31LmU","preloaderOverlay":"index-module_preloaderOverlay_H52Vf"};


//////////////////
// WEBPACK FOOTER
// ./client/components/experiment/index.module.css
// module id = 299
// module chunks = 1 2 3